export default __webpack_public_path__ + "static/media/capital_section_image_desktop.c7d6eb94.jpg";